import styled, { css } from 'styled-components';

import { EColor } from '@core/type';
import { getPaletteHandlers } from '@core/util';

import { Box } from '../layout';
import { ProgressBarProps } from './interface-progress-bar';

const MAX_WIDTH_IN_PERCENT = 100;

const StyledProgressBarLine = styled('div').attrs<ProgressBarProps>(
  ({ currentStep, totalSteps }) => ({
    style: {
      width: `${(currentStep / totalSteps) * MAX_WIDTH_IN_PERCENT}%`,
    },
  }),
)(({ theme: { palette } }) => {
  const { getColor } = getPaletteHandlers(palette);

  return css`
    background-color: ${getColor({
      semanticType: EColor.SECONDARY,
      variant: EColor.DARK,
    })};
    height: 100%;
    width: 0;
    border-radius: 4px;
    transition: width 0.5s ease-out;
  `;
});

export const ProgressBar = ({ currentStep = 0, totalSteps }: ProgressBarProps) => (
  <Box
    width={'100%'}
    backgroundColor={{ commonType: EColor.GRAY, intensity: EColor.A200 }}
    height={'6px'}
  >
    <StyledProgressBarLine currentStep={currentStep} totalSteps={totalSteps} />
  </Box>
);
